import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import EmployeeProfileHeader from '../../components/employees/EmployeeProfileHeader.jsx';
import Empty from '../../components/Empty.jsx';
import { loadingContent } from '../../components/EmptyStates.jsx';
import { EMPLOYEE_PROFILE_SEARCH_DEBOUNCE_MS } from '../../constants/employeeProfile.js';
import useDebouncedUrlSearch from '../../hooks/useDebouncedUrlSearch.js';
import { retrieveEmployee, selectEmployee } from '../../modules/employees.js';
import { retrieveUser, selectUser } from '../../modules/users.js';
import {
  selectUser as selectCurrentUser,
  selectUserPermissions,
} from '../../modules/auth.js';

const mapStateToProps = (state, ownProps) => {
  const employee = selectEmployee(ownProps.employeeId)(state);
  const employeeUser = employee?.userId
    ? selectUser(employee.userId)(state)
    : null;
  return {
    currentUser: selectCurrentUser(state),
    permissions: selectUserPermissions(state),
    employee,
    employeeUser,
  };
};

const mapDispatchToProps = {
  retrieveEmployee,
  retrieveUser,
};

// Shared header for all employee profile tabs: breadcrumb, tabs, employee card
// and the tab-aware search field (writes ?search= to the URL, debounced).
const EmployeeProfileHeaderContainer = ({
  employeeId,
  // false when the tab itself fetches GET employees/:id (Initiatives tab)
  fetchEmployee = true,
  employee,
  employeeUser,
  currentUser,
  permissions,
  retrieveEmployee,
  retrieveUser,
}) => {
  const [searchValue, setSearchValue, appliedSearch] = useDebouncedUrlSearch(
    EMPLOYEE_PROFILE_SEARCH_DEBOUNCE_MS
  );

  useEffect(() => {
    if (fetchEmployee) retrieveEmployee(employeeId);
  }, [employeeId]);

  useEffect(() => {
    if (employee?.userId && !employeeUser) {
      retrieveUser(employee.userId);
    }
  }, [employee]);

  if (!employee) {
    return <Empty simplified content={loadingContent} />;
  }

  return (
    <EmployeeProfileHeader
      employee={employee}
      employeeUser={employeeUser}
      currentUser={currentUser}
      permissions={permissions}
      searchValue={searchValue}
      appliedSearch={appliedSearch}
      onSearchChange={setSearchValue}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeProfileHeaderContainer);
